module.exports = __webpack_public_path__ + "media/images/emblems/Feuerthalen-blazon-6d7fe2a5c1f2553c92868437cc4bf36f.svg";